import { Link as RouterLink } from "react-router-dom";
import { Box, Typography, Button } from "@mui/material";

export default function NotFound() {
  return (
    <Box sx={{ textAlign: "center", py: { xs: 6, sm: 10 } }}>
      <Typography variant="h2" sx={{ fontWeight: 700, letterSpacing: "-0.025em", mb: 1 }}>
        404
      </Typography>
      <Typography variant="h6" color="text.secondary" sx={{ mb: 3, fontWeight: 400 }}>
        Sorry, that page doesn't exist.
      </Typography>
      <Button component={RouterLink} to="/" variant="contained">
        Back to home
      </Button>
    </Box>
  );
}
